import { PartialBrief } from '../../../../Types/Brief'

export type DateRange = [Date | undefined, Date | undefined]

export const getBriefDates = (brief: PartialBrief): DateRange => {
  const startDate = (brief.fromDate && new Date(brief.fromDate)) || undefined
  const endDate = (brief.toDate && new Date(brief.toDate)) || undefined

  return [startDate, endDate]
}
